
import AIGeneratorForm from "../AIPackage/AIGeneratorForm";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useMemo } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RiCalendar2Line } from "react-icons/ri";
import Select from "react-select";
import currencies from "../../Data/Currency.json";
import PackageDateModal from "./PackageDateModal";
import ImageViewModal from "./ImageViewModal";
import './PackageForm.css';
import AILandPackageForm from "../AIPackage/AILandPackageForm";
import SupplierAIGeneratorForm from "../AIPackage/AIWithSupplierGenerator";
import packageDestinationsData from '../../Data/PackageDestinations.json';
import UpgradeModal from "../Master/UpgradeModal";


const DEFAULT_IMAGE = "/assets/images/default-package.jpg";

const initialFieldValues = {
  packageId: "00000000-0000-0000-0000-000000000000",
  destination: "",
  travelType: "FAMILY",
  companyId: "00000000-0000-0000-0000-000000000000",
  userId: "00000000-0000-0000-0000-000000000000",
  fromOriginId: "",
  packageDateId: "",
  imageName: "",
  imageFile: null,
  imageSrc: DEFAULT_IMAGE,
  packageName: "",
  noOfPersons: "1",
  adults: "0",
  kids: "0",
  infants: "0",
  startedDate: moment().format("DD-MMM-YYYY"),
  duration: "3 Nights / 4 Days",
  includes: "flight, hotel, food",
  description: "",
  destinationsCover: "",
  price: "",
  status: "Active",
  type: "Holiday",
  contactName: "",
  contactPhoneNumber: "",
  contactEmail: "",
  currency: "",
};

const CustomDateInput = React.forwardRef(({ value, onClick, errorClass }, ref) => (
  <div className="input-group">
    <input
      type="text"
      className={`form-control ${errorClass}`}
      value={value}
      onClick={onClick}
      ref={ref}
      readOnly
    />
    <div className="input-group-text bg-primary border-primary text-white" style={{ cursor: "pointer" }} onClick={onClick}>
      <RiCalendar2Line />
    </div>
  </div>
));

const PackageForm = ({
  packageId,
  isEditMode,
  setIsEditMode,
  onPackageCreated,
  onAiPackageGenerated,
  packageDetails,
}) => {
  const { user, loading, refreshUserProfile } = useAuth();
  const navigate = useNavigate();
  const [showAiModal, setShowAiModal] = useState(false);
  const [showPackageTypeSelectionModal, setShowPackageTypeSelectionModal] = useState(false);
  const [showFlightAiModal, setShowFlightAiModal] = useState(false);
  const [showLandAiModal, setShowLandAiModal] = useState(false);
  const [showSupplierAiModal, setShowSupplierAiModal] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [isCheckingConnects, setIsCheckingConnects] = useState(false);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [pageSize] = useState(20);
  const [pageNumber] = useState(1);
  //const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showImageViewModal, setShowImageViewModal] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const flatpickrRef = useRef(null);
  const fileInputRef = useRef(null);
  const [packageDates, setPackageDates] = useState([]);
  const [showPackageDateModal, setShowPackageDateModal] = useState(false);
  const [imagePreview, setImagePreview] = useState(DEFAULT_IMAGE);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const handleGenerateWithAIClick = async () => {
    // Set loading state to true immediately
    setIsCheckingConnects(true);
    
    try {
        const updatedProfile = await refreshUserProfile();
        
        if (updatedProfile && updatedProfile.connects > 0) {
            setShowPackageTypeSelectionModal(true);
        } else {
            toast.error("You have no AI connects left. Please recharge to continue.");
        }
    } catch (error) {
        // Handle potential errors from refreshUserProfile if necessary
        toast.error("Could not verify your connects balance. Please try again.");
        console.error("Error checking connects:", error);
    } finally {
        // Set loading state back to false after the check is complete
        setIsCheckingConnects(false);
    }
  };
  const handleAiGenerateAndSave = async (payloadFromAIForm) => {
    setIsGenerating(true);

    try {
      const response = await apiService.post(
        config.GENRATEANDSAVE,
        payloadFromAIForm
      );

      if (response && response.success && response.packageId) {
        toast.success("AI package created successfully!");
        onAiPackageGenerated(response.packageId);
        await refreshUserProfile();
      } else {
        toast.error(response.message || "Failed to create package via AI.");
      }
    }
    catch (error) {

      // Axios puts the response data inside error.response.data
      const errorMessage = error.response?.data?.message || "An unexpected error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsGenerating(false);
      setShowFlightAiModal(false);
      setShowLandAiModal(false);
    }

  };
  const handleSupplierAiGenerateAndSave = async (payloadFromAIForm) => {
    setIsGenerating(true);
    try {
      // Use the new AISUPPLIERGENRATE endpoint

      const response = await apiService.post(config.AISUPPLIERGENRATEANDSAVE, payloadFromAIForm);
      if (response && response.success && response.packageId) {
        toast.success("AI supplier package created successfully!");
        onAiPackageGenerated(response.packageId);
        await refreshUserProfile();
      } else {
        toast.error(response.message || "Failed to create supplier package via AI.");
      }
    }
    catch (error) {

      const errorMessage = error.response?.data?.message || "An unexpected error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsGenerating(false);
      // Close the correct modal
      setShowSupplierAiModal(false);
    }
  };

  const openFlightAiModal = () => {
    setShowPackageTypeSelectionModal(false);
    setShowFlightAiModal(true);
  };

  const openLandAiModal = () => {
    setShowPackageTypeSelectionModal(false);
    setShowLandAiModal(true);
  };
  const openSupplierAiModal = () => {
    const allowedPlans = ['STARTER', 'PRO', 'ENTERPRISE']; // Use the exact names from your backend
    if (user && allowedPlans.includes(user.planType?.toUpperCase())) {
      setShowPackageTypeSelectionModal(false);
      setShowSupplierAiModal(true);
    } else {
      setShowUpgradeModal(true);
    }
  };
  
 const allDestinations = useMemo(() => {
    const destinationList = [];
    if (packageDestinationsData) {
      packageDestinationsData.forEach(countryData => {
        if (countryData.Destination) {
          destinationList.push(countryData.Destination);
          if (countryData.Places && Array.isArray(countryData.Places)) {
            countryData.Places.forEach(place => {
              destinationList.push(`${place}-${countryData.Destination}`);
            });
          }
        }
      });
    }
    return destinationList;
  }, []);

  const handleDestinationChange = (e) => {
    const userInput = e.target.value;
    setValues({ ...values, destination: userInput });

    if (userInput) {
      // Use the new allDestinations list for filtering
      const filteredSuggestions = allDestinations.filter(
        suggestion => suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
      );
      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

const handleSuggestionClick = (suggestion) => {
    const mainDestinationName = suggestion.includes('-') ? suggestion.split('-').pop() : suggestion;

    const destinationData = packageDestinationsData.find(
      item => item.Destination.toLowerCase() === mainDestinationName.toLowerCase()
    );

    if (destinationData) {
      setValues(prevValues => ({
        ...prevValues,
        destination: suggestion,
        description: destinationData.Description, // Auto-populate the description
      }));
    } else {
      setValues(prevValues => ({ ...prevValues, destination: suggestion }));
    }
    setSuggestions([]);
    setShowSuggestions(false);
  };

  useEffect(() => {
    if (packageDetails) {
      setValues({
        ...initialFieldValues, // Start with a clean slate to prevent merging old fields
        ...packageDetails,      // Spread the new package details
        // Ensure date is correctly formatted
        startedDate: moment(packageDetails.startedDate).format("DD-MMM-YYYY"),
      });
      setImagePreview(packageDetails.imageSrc || DEFAULT_IMAGE);
      setIsEditMode(true);
    } else {
      // --- CREATE MODE ---
      // No package details, so we are creating a new package.

      // Start with the default initial values.
      const newValues = { ...initialFieldValues };

      // If the user object is available, pre-fill their contact info.
      if (user) {
        newValues.contactName = user.name || "";
        newValues.contactPhoneNumber = user.phoneNumber || "";
        newValues.contactEmail = user.email || "";
        newValues.currency = user.currency || "INR";
      }

      setValues(newValues);
      setImagePreview(DEFAULT_IMAGE);
      setIsEditMode(false);
      setErrors({}); // Also ensure any lingering validation errors are cleared
    }
  }, [packageDetails, user, setIsEditMode]);

  const GetPackageDates = async (packageType) => {
    try {
      const url = `${config.GETDATESBYTYPE}/${user.cid}?type=${packageType}`;
      const res = await apiService.getAll(url);
      setPackageDates(res);
    } catch (error) {
      console.error("Error fetching package dates:", error);
      setPackageDates([]);
    }
  };

  const handlePackageDateCreated = () => GetPackageDates("Holiday");

  useEffect(() => {
    GetPackageDates("Holiday");
  }, []);

  const validate = () => {
    let temp = {};
    temp.destination =
      values.destination !== "00000000-0000-0000-0000-000000000000";
    temp.packageName = values.packageName !== "";
    temp.duration = values.duration !== "";
    temp.startedDate = values.startedDate !== "";
    temp.noOfPersons = values.noOfPersons !== "" && values.noOfPersons > 0;
    temp.price = values.price !== "" && !isNaN(values.price);
    temp.currency = values.currency !== "";
    temp.description = values.description !== "";
    temp.imageFile = isEditMode ? true : values.imageFile !== null;
    temp.status = values.status !== "";

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  // const handleImageUpload = (file, imageSrc) => {
  //   setImagePreview(imageSrc);
  //   setValues({
  //     ...values,
  //     imageFile: file,
  //     imageSrc: imageSrc,
  //     imageName: file ? file.name : "default-package.jpg",
  //   });
  // };
  const handleFileSelected = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Optional: Add validation for file type or size here if needed
      // e.g., if (!file.type.startsWith('image/')) { ... }

      const reader = new FileReader();
      reader.onloadend = () => {
        const imageSrc = reader.result; // This will be a base64 string
        setImagePreview(imageSrc);
        setValues({
          ...values,
          imageFile: file,
          imageSrc: imageSrc, // Store the base64 string
          imageName: file.name,
        });
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const formData = new FormData();
      Object.entries({
        ...values,
        companyId: user?.cid,
        userId: user?.id,
      }).forEach(([key, value]) => formData.append(key, value ?? ""));

      if (values.imageFile) {
        formData.append("imageFile", values.imageFile);
      }

      try {
        if (isEditMode) {

          await apiService.update(config.UPDATEPACKAGE, formData);


        } else {
          // --- CREATE LOGIC ---
          // apiService.create will show the success toast.
          const response = await apiService.create(
            config.CREATEPACKAGE,
            formData
          );

          // After successful creation, we navigate to the new package's edit page.
          if (response && response.packageId) {
            onPackageCreated(response.packageId);
          }
        }
      } catch (error) {
        // The apiService's handleError will show an error toast,
        // so we only need to log it here for debugging if we want.
        console.error("Error submitting form:", error);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handlePersonChange = (amount) => {
    setValues((prev) => {
      const currentPersons = parseInt(prev.noOfPersons, 10) || 0;
      const newPersons = Math.max(1, currentPersons + amount);
      return { ...prev, noOfPersons: newPersons.toString() };
    });
  };


  const resetForm = () => {
    const contactInfo = {
      contactName: values.contactName,
      contactPhoneNumber: values.contactPhoneNumber,
      contactEmail: values.contactEmail,
      currency: values.currency,
    };
    setValues({ ...initialFieldValues, ...contactInfo });
    setImagePreview(DEFAULT_IMAGE);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  const handleSwitchToLand = () => {
    setShowFlightAiModal(false);
    setShowSupplierAiModal(false);
    setShowLandAiModal(true);
  };

  const handleSwitchToFlight = () => {
    setShowLandAiModal(false);
    setShowSupplierAiModal(false);
    setShowFlightAiModal(true);
  };

  const handleSwitchToManual = () => {
    setShowFlightAiModal(false);
    setShowSupplierAiModal(false);
    setShowLandAiModal(false);
  };
  const handleSwitchToSupplier = () => {
    const allowedPlans = ['STARTER', 'PRO', 'ENTERPRISE']; // Use the exact names from your backend
    if (user && allowedPlans.includes(user.planType?.toUpperCase())) {
      setShowFlightAiModal(false);
      setShowLandAiModal(false);
      setShowSupplierAiModal(true);
    } else {
      setShowUpgradeModal(true);
    }
  };

  return (
    <div className="PackageForm-wrapper">
      <Modal show={showPackageTypeSelectionModal} onHide={() => setShowPackageTypeSelectionModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select AI Package Type</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-4">What kind of package would you like to generate?</p>
          <div className="d-grid gap-3">
            <button className="btn btn-primary btn-lg" onClick={openFlightAiModal}>
              <i className="ri-plane-line me-2"></i>Flight Package
              <small className="d-block text-white-50">Includes flights in the itinerary</small>
            </button>
            <button className="btn btn-success btn-lg" onClick={openLandAiModal}>
              <i className="ri-road-map-line me-2"></i>Land Package
              <small className="d-block text-white-50">Flights are not included</small>
            </button>
            <button className="btn btn-warning btn-lg" onClick={openSupplierAiModal}>
              <i className="ri-price-tag-3-line me-2"></i>Supplier Price
              <small className="d-block text-white-50">flights included</small>
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showFlightAiModal} onHide={() => setShowFlightAiModal(false)} size="xl" dialogClassName="ai-generator-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>✨ Generate Flight Package with AI</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AIGeneratorForm
            onGenerate={handleAiGenerateAndSave}
            isGenerating={isGenerating}
            onSwitchToLand={handleSwitchToLand}
            onSwitchToManual={handleSwitchToManual}
            onSwitchToSupplier={handleSwitchToSupplier}
          />
        </Modal.Body>
      </Modal>

      {/* 3. The Land AI Form Modal */}
      <Modal show={showLandAiModal} onHide={() => setShowLandAiModal(false)} size="xl" dialogClassName="ai-generator-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>✨ Generate Land Package with AI</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AILandPackageForm
            onGenerate={handleAiGenerateAndSave}
            isGenerating={isGenerating}
            onSwitchToFlight={handleSwitchToFlight}
            onSwitchToManual={handleSwitchToManual}
            onSwitchToSupplier={handleSwitchToSupplier}
          />
        </Modal.Body>
      </Modal>
      {/* STEP 6: Add the Modal for the new Supplier AI Form */}
      <Modal show={showSupplierAiModal} onHide={() => setShowSupplierAiModal(false)} size="xl" dialogClassName="ai-generator-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>✨ Generate Supplier Package with AI</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SupplierAIGeneratorForm
            onGenerate={handleSupplierAiGenerateAndSave}
            isGenerating={isGenerating}
            onSwitchToFlight={handleSwitchToFlight}
            onSwitchToLand={handleSwitchToLand}
            onSwitchToManual={handleSwitchToManual}
          />
        </Modal.Body>
      </Modal>
      <PackageDateModal show={showPackageDateModal} onHide={() => setShowPackageDateModal(false)} onPackageDateCreated={handlePackageDateCreated} type="Holiday" />
      {/* <ImageUploadModal show={showImageUploadModal} onHide={() => setShowImageUploadModal(false)} onImageUpload={handleImageUpload} title="Upload Package Image" defaultImage={DEFAULT_IMAGE} aspectRatio="4/3" /> */}
      <ImageViewModal show={showImageViewModal} onHide={() => setShowImageViewModal(false)} imageSrc={imagePreview} title="Package Image" defaultImage={DEFAULT_IMAGE} aspectRatio="4/3" />

      <div className="PackageForm-header d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">{isEditMode ? "Edit Package" : "Create a New Package"}</h5>
      </div>
      <form onSubmit={handleSubmit} autoComplete="off" noValidate>
        <div className="card PackageForm-section-card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">

                  <div className="col-md-6 mb-3 Destinationautocomplete-container">
                    <label className="PackageForm-label form-label d-flex align-items-center">
                      <i className="ri-map-pin-line me-2"></i>Destination
                    </label>
                    <input
                      type="text"
                      name="destination"
                      value={values.destination}
                      onChange={handleDestinationChange} // <-- Use the new handler
                      className={"form-control" + applyErrorClass("destination")}
                      placeholder="Dubai or Paris"
                      autoComplete="off"
                      onBlur={() => {
                        setTimeout(() => {
                          setShowSuggestions(false);
                        }, 200);
                      }}
                    />
                    {showSuggestions && suggestions.length > 0 && (
                      <ul className="Destinationautocomplete-suggestions-list">
                        {suggestions.slice(0, 10).map((suggestion, index) => (
                          <li
                            key={index}
                            className="Destinationautocomplete-suggestion-item"
                            onMouseDown={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion}
                          </li>
                        ))}
                      </ul>
                    )}
                    {errors.destination === false && (
                      <div className="validationerror">
                        Please enter a destination
                      </div>
                    )}
                  </div>


                  {/* ✅ Travel Type Second */}
                  <div className="col-md-6 mb-3">
                    <label className="PackageForm-label form-label d-flex align-items-center">
                      <i className="ri-suitcase-line me-2"></i>Travel Type
                    </label>
                    <select
                      name="travelType"
                      value={values.travelType}
                      onChange={handleInputChange}
                      className={"form-select" + applyErrorClass("travelType")}
                    >
                      <option value="">Select Travel Type</option>
                      <option value="FAMILY">FAMILY</option>
                      <option value="CORPORATE">CORPORATE</option>
                      <option value="GROUP">GROUP</option>
                      <option value="HONEYMOON">HONEYMOON</option>
                    </select>
                    {errors.travelType === false && (
                      <div className="validationerror">Please select a travel type</div>
                    )}
                  </div>

                  {/* ✅ Package Name Last */}
                  <div className="col-12 mb-3">
                    <label className="PackageForm-label form-label d-flex align-items-center">
                      <i className="ri-medal-line me-2"></i>Package Name
                    </label>
                    <input
                      type="text"
                      name="packageName"
                      value={values.packageName}
                      onChange={handleInputChange}
                      className={
                        "form-control form-control-md" + applyErrorClass("packageName")
                      }
                      placeholder="e.g. A 5-Day Luxury Escape to Dubai"
                    />
                    {errors.packageName === false && (
                      <div className="validationerror">Please enter package name</div>
                    )}
                  </div>
                </div>


              </div>
              {/* <div className="col-lg-4">
                <div className={`PackageForm-image-upload-box text-center p-1 border rounded ${errors.imageFile === false && !isEditMode ? 'border-danger' : ''}`}>
                  <img
                    src={imagePreview}
                    alt="Package Preview"
                    className="img-fluid rounded mb-3"
                    style={{ maxHeight: "150px" }}
                  />
                  <div className="d-flex gap-2 justify-content-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => setShowImageUploadModal(true)}
                    >
                      <i className="ri-upload-2-line me-1"></i> Upload
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setShowImageViewModal(true)}
                    >
                      <i className="ri-eye-line me-1"></i> View
                    </button>
                  </div>
                  {/* This error message will now show correctly based on the new validation logic */}
              {/* {errors.imageFile === false && !isEditMode && (
                    <div className="validationerror mt-2">
                      Please upload an image
                    </div>
                  )}
                </div>
              </div>  */}
              <div className="col-lg-4">
                {/* --- STEP 3.2: ADD THE HIDDEN FILE INPUT --- */}
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileSelected}
                  style={{ display: 'none' }}
                  accept="image/png, image/jpeg, image/gif" // Good practice to specify accepted formats
                />

                <div className={`PackageForm-image-upload-box text-center p-1 border rounded ${errors.imageFile === false && !isEditMode ? 'border-danger' : ''}`}>
                  <img
                    src={imagePreview}
                    alt="Package Preview"
                    className="img-fluid rounded mb-3"
                    style={{ maxHeight: "150px" }}
                  />
                  <div className="d-flex gap-2 justify-content-center">
                    {/* --- STEP 3.3: CHANGE THE ONCLICK HANDLER --- */}
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => fileInputRef.current.click()} // <-- CHANGE THIS LINE
                    >
                      <i className="ri-upload-2-line me-1"></i> Upload
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setShowImageViewModal(true)}
                    >
                      <i className="ri-eye-line me-1"></i> View
                    </button>
                  </div>
                  {errors.imageFile === false && !isEditMode && (
                    <div className="validationerror mt-2">
                      Please upload an image
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
               <div className="col-md-3 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center">
                  <i className="ri-calendar-event-line me-2"></i>Travel Date
                </label>
                <DatePicker
                  selected={moment(values.startedDate, "DD-MMM-YYYY").toDate()}
                  onChange={(date) => {
                    handleInputChange({
                      target: {
                        name: "startedDate",
                        value: moment(date).format("DD-MMM-YYYY"),
                      },
                    });
                  }}
                  customInput={<CustomDateInput errorClass={applyErrorClass("startedDate")} />}
                  dateFormat="dd-MMM-yyyy"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  minDate={new Date()}
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown
                />
                {errors.startedDate === false && <div className="validationerror">Please select</div>}
              </div>
              <div className="col-md-3 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-time-line me-2"></i>Duration</label>
                <select name="duration" value={values.duration} onChange={handleInputChange} className={"form-select " + applyErrorClass("duration")}>
                  <option value="">Select Duration</option>
                  {Array.from({ length: 30 }, (_, i) => {
                    const nights = i + 1; const days = nights + 1;
                    return <option key={nights} value={`${nights} Nights / ${days} Days`}>{`${nights} Night${nights > 1 ? "s" : ""} / ${days} Day${days > 1 ? "s" : ""}`}</option>;
                  })}
                </select>
                {errors.duration === false && <div className="validationerror">Please select</div>}
              </div>
              <div className="col-md-2 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-group-line me-2"></i>No of Persons</label>
                <div className="input-group">
                  <button className="btn btn-outline-secondary" type="button" onClick={() => handlePersonChange(-1)}>-</button>
                  <input type="number" name="noOfPersons" value={values.noOfPersons} onChange={handleInputChange} className={"form-control text-center" + applyErrorClass("noOfPersons")} min="1" />
                  <button className="btn btn-outline-secondary" type="button" onClick={() => handlePersonChange(1)}>+</button>
                </div>
                {errors.noOfPersons === false && <div className="validationerror">Enter a valid number of persons</div>}
              </div>
              <div className="col-md-3 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-money-dollar-circle-line me-2"></i>Price Per Person</label>
                <div className="input-group">
                  <select name="currency" value={values.currency} onChange={handleInputChange} className={"input-group-text" + applyErrorClass("currency")}>
                    {currencies.map((c) => <option key={c.code} value={c.code}>{c.code}</option>)}
                  </select>
                  <input type="number" name="price" value={values.price} onChange={handleInputChange} className={"form-control " + applyErrorClass("price")} placeholder="2000" min="1" />
                </div>
                {errors.price === false && <div className="validationerror">Please enter a valid price</div>}
              </div>
              <div className="col-12 mb-3">
                <label className="PackageForm-label form-label d-flex align-items-center"><i className="ri-file-text-line me-2"></i>Description</label>
                <textarea name="description" value={values.description} onChange={handleInputChange} className={"form-control " + applyErrorClass("description")} placeholder="Give a captivating description of the travel package..." rows="4"></textarea>
                {errors.description === false && <div className="validationerror">Please enter description</div>}
              </div>
            </div>

            <div className="col-12 text-center my-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowAdvanced(!showAdvanced)}
              >
                {showAdvanced ? "Hide" : "Show"} Advanced Options{" "}
                <i
                  className={`ri-arrow-${showAdvanced ? "up" : "down"
                    }-s-line align-middle`}
                ></i>
              </button>
            </div>
          </div>
        </div>

        {/* --- ADVANCED SECTION --- */}
        {showAdvanced && (
          <div
            className="card form-section-card"
            style={{ backgroundColor: "#c1d56aff" }}
          >
            <div className="card-body">
              <h5 className="section-title">Advanced Details</h5>
              <div className="row">
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center">
                    <i className="ri-road-map-line me-2"></i>Destinations Cover
                  </label>
                  <input
                    type="text"
                    name="destinationsCover"
                    value={values.destinationsCover}
                    onChange={handleInputChange}
                    className={
                      "form-control " + applyErrorClass("destinationsCover")
                    }
                    placeholder="e.g. Dubai, Abu Dhabi"
                  />
                  {errors.destinationsCover === false && (
                    <div className="validationerror">
                      Please enter destinations covered
                    </div>
                  )}
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center">
                    <i className="ri-check-double-line me-2"></i>Includes
                  </label>
                  <Select
                    isMulti
                    options={[
                      { value: "food", label: "Food" },
                      { value: "hotel", label: "Hotel" },
                      { value: "flight", label: "Flight" },
                    ]}
                    value={
                      values.includes
                        ? values.includes
                          .split(", ")
                          .map((item) => ({
                            value: item,
                            label:
                              item.charAt(0).toUpperCase() + item.slice(1),
                          }))
                        : []
                    }
                    onChange={(opts) =>
                      setValues({
                        ...values,
                        includes: opts.map((o) => o.value).join(", "),
                      })
                    }
                    className={
                      "react-select-container" +
                      (errors.includes === false ? " is-invalid" : "")
                    }
                    classNamePrefix="react-select"
                  />
                  {errors.includes === false && (
                    <div className="invalid-feedback d-block">
                      Please select at least one option
                    </div>
                  )}
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center">
                    <i className="ri-calendar-2-line me-2"></i>Package Dates
                  </label>
                  <div className="input-group">
                    <select
                      name="packageDateId"
                      value={values.packageDateId}
                      onChange={handleInputChange}
                      className={
                        "form-select" + applyErrorClass("packageDateId")
                      }
                    >
                      <option value="">Please select a date range</option>
                      {packageDates.map((pd) => (
                        <option
                          key={pd.packageDateId}
                          value={pd.packageDateId}
                        >{`${moment(pd.startDate).format(
                          "DD MMM YYYY"
                        )} - ${moment(pd.endDate).format(
                          "DD MMM YYYY"
                        )}`}</option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPackageDateModal(true)}
                    >
                      +
                    </button>
                  </div>
                  {errors.packageDateId === false && (
                    <div className="validationerror">
                      Please select a date range
                    </div>
                  )}
                </div>
                <div className="col-lg-6 mb-3">
                  <label className="form-label d-flex align-items-center">
                    <i className="ri-toggle-line me-2"></i>Status
                  </label>
                  <select
                    name="status"
                    value={values.status}
                    onChange={handleInputChange}
                    className={"form-select " + applyErrorClass("status")}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {errors.status === false && (
                    <div className="validationerror">
                      Please select a status
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="card form-section-card"
          style={{ backgroundColor: "#6aa0d5ff" }}
        >
          <div className="card-body">
            <h5 className="section-title">Contact Information</h5>
            <div className="row">
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center">
                  <i className="ri-user-line me-2"></i>Contact Name
                </label>
                <input
                  type="text"
                  name="contactName"
                  value={values.contactName}
                  onChange={handleInputChange}
                  className={"form-control " + applyErrorClass("contactName")}
                  placeholder="e.g Rajesh"
                />
                {errors.contactName === false && (
                  <div className="validationerror">
                    Please enter contact name
                  </div>
                )}
              </div>
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center">
                  <i className="ri-phone-line me-2"></i>Contact Phone
                </label>
                <input
                  type="tel"
                  maxLength={15}
                  name="contactPhoneNumber"
                  value={values.contactPhoneNumber}
                  onChange={handleInputChange}
                  className={
                    "form-control " + applyErrorClass("contactPhoneNumber")
                  }
                  placeholder="e.g 9999999999"
                />
                {errors.contactPhoneNumber === false && (
                  <div className="validationerror">
                    Please enter contact phone
                  </div>
                )}
              </div>
              <div className="col-lg-4 mb-3">
                <label className="form-label d-flex align-items-center">
                  <i className="ri-mail-line me-2"></i>Contact Email
                </label>
                <input
                  type="text"
                  maxLength={40}
                  name="contactEmail"
                  value={values.contactEmail}
                  onChange={handleInputChange}
                  className={"form-control " + applyErrorClass("contactEmail")}
                  placeholder="e.g rajesh@gmail.com"
                />
                {errors.contactEmail === false && (
                  <div className="validationerror">
                    Please enter contact email
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="PackageForm-actions-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={resetForm}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={btnLoading}
            >
              {btnLoading
                ? "Saving..."
                : isEditMode
                  ? "Update Package"
                  : "Create Package"}
            </button>
          </div>
        </div>
      </form>
      <UpgradeModal show={showUpgradeModal} handleClose={() => setShowUpgradeModal(false)} />
    </div>
  );
};

export default PackageForm;
